import FullCalendar from "@fullcalendar/react";
import themePlugin from "@fullcalendar/react/themes/monarch";
import timegridPlugin from "@fullcalendar/react/timegrid";
import daygridPlugin from "@fullcalendar/react/daygrid";
import rrulePlugin from "@fullcalendar/rrule";

// stylesheets
import '@fullcalendar/react/skeleton.css';
import '@fullcalendar/react/themes/monarch/theme.css';
import '@fullcalendar/react/themes/monarch/palettes/blue.css';
import { useStore } from "./Store";
import { rrulestr } from "rrule";

const Schedule: React.FC = () => {
  const { store, selectJam } = useStore();


  return (
    <div>
      <FullCalendar
        plugins={[themePlugin, daygridPlugin, rrulePlugin]}
        initialView="dayGridMonth"
        colorScheme="dark"
        firstDay={1}
        height={500}
        eventClick={({ event }) => {
          if (store.loaded) {
            selectJam(event.extendedProps.id);
          }
        }}
        headerToolbar={{
          start: 'title',
          center: '',
          end: 'today prev,next'
        }}
        events={
          store.loaded ? store.jams.map(item => {
            const rule = rrulestr(item.time.rrule, { tzid: 'Europe/London'})
            return {
              title: item.name,
              editable: false,
              overlap: true,
              rrule: rule.toString(),
              extendedProps: {
                id: item.id
              },
              className: 'cursor-pointer'
            };
          }
          ) : []
        }
      />
    </div>
  );
};

export default Schedule;
